var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Multiselect", {
    attrs: {
      label: "displayName",
      "track-by": "displayName",
      disabled: _vm.isDisabled,
      options: _vm.calendars,
      value: _vm.calendar
    },
    on: { select: _vm.change },
    scopedSlots: _vm._u([
      {
        key: "singleLabel",
        fn: function(scope) {
          return [
            _c(
              "CalendarPickerOption",
              _vm._b({}, "CalendarPickerOption", scope.option, false)
            )
          ]
        }
      },
      {
        key: "option",
        fn: function(scope) {
          return [
            _c(
              "CalendarPickerOption",
              _vm._b({}, "CalendarPickerOption", scope.option, false)
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }